import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IParsedMessage, TMessagesMap } from '../../../utils/messageUtils';
import { IMessagesQueueState } from '../../types/messagesQueue';
import { SliceActions } from '../types';

export const initialState: IMessagesQueueState = {
  list: [],
};

const messagesQueueSlice = createSlice({
  name: 'messagesQueue',
  reducers: {
    addMessageInQueue: (
      state,
      action: PayloadAction<{
        parsedMessage: IParsedMessage;
        messagesMap: TMessagesMap;
      }>,
    ) => {
      const existingMessageIndex = state.list.findIndex(c => c.messageId === action.payload.parsedMessage.messageId);
      if (existingMessageIndex === -1) {
        state.list.push({
          messageId: action.payload.parsedMessage.messageId,
          isShow: false,
          chatId: action.payload.parsedMessage.chatId,
        });
        action.payload.messagesMap.set(action.payload.parsedMessage.messageId, {
          message: action.payload.parsedMessage,
          messageIndex: state.list.length - 1,
        });
      }
    },
    editMessageInQueue: (
      state,
      action: PayloadAction<{
        messageId: string;
        isShow: boolean;
      }>,
    ) => {
      const existingMessageIndex = state.list.findIndex(c => c.messageId === action.payload.messageId);
      if (existingMessageIndex !== -1) {
        state.list[existingMessageIndex].isShow = action.payload.isShow;
      }
    },
  },
  selectors: {
    selectAllMessagesInQueue: state => state,
  },
  initialState,
});

export const messagesQueueReducer = messagesQueueSlice.reducer;
export const { addMessageInQueue, editMessageInQueue } = messagesQueueSlice.actions;
export const { selectAllMessagesInQueue } = messagesQueueSlice.selectors;
export type TMessagesQueueActions = SliceActions<typeof messagesQueueSlice.actions>;
